// extracted by mini-css-extract-plugin
export default {"truncate":"VideoGrid_truncate__xnY85","shadow":"VideoGrid_shadow__dWfuL"};